<template>
  <div>
    <ul class="report-wrap">
      <li class="report-item animate__animated animate__backInLeft" v-for="(item, index) in reportList" :key="index">
        <img :src="item.headImg" alt="" class="avatar" />
        <div>
          <h3 class="name">{{ item.name }}</h3>
          <div class="job">
            <span v-for="(tag, count) in item.titles" :key="count" class="job-tag">{{
              tag
            }}</span>
          </div>
          <div class="detail">{{ item.desc }}</div>
          <div class="link-wrap" @click="showVideo(item)">
              {{ item.video_name }}
              <img src="../../assets/image/play_icon.png" alt="" class="play-icon">
          </div>
        </div>
      </li>
    </ul>

    <el-dialog  
     :visible.sync="dialogVisible"
     :title="videoTitle"
      @close="close"
      width="800px"
      :close-on-click-modal="false">
        <video :src="videoUrl" style="width: 100%;height: auto;" controls loop="loop" preload="auto" autoplay></video>
    </el-dialog>
  </div>
</template>

<script>
import list from '@/mock/report.json'
export default {
  data() {
    return {
      reportList: list,
      videoUrl: '',
      videoTitle: '',
      dialogVisible: false
    };
  },
  methods: {
      close(){
           this.dialogVisible = false;
      },
      showVideo(video){
        console.log(video)
          this.videoUrl = video.video_url;
          this.videoTitle = video.video_name;
          this.dialogVisible = true;
      }
  }
};
</script>

<style scoped lang="scss">
.report-item {
  display: flex;
  align-items: center;
  background: #eee;
  margin-bottom: 20px;
  line-height: 24px;
  font-size: 12px;
  padding: 5px;
  .avatar {
    height: 130px;
    width: auto;
    margin-right: 20px;
  }
  .name{
      line-height: 36px;
      font-size: 16px;
  }
  .job-tag{
      margin-right: 10px;
  }
  .detail{
      color: #999;
      margin-top: 5px;
  }
  .link-wrap{
    background: #4da4ff;
    color: #fff;
    display: inline-block;
    padding: 0 5px;
    cursor: pointer;
    .link{
        color: #fff;
        text-decoration: none;
        padding: 0 5px;
        vertical-align: middle;
    }
    .play-icon{
        width: 18px;
        height: 18px;
        vertical-align: text-top ;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/report.vue